import { create } from "zustand";

interface ErrorState {
  readonly title: string;
  readonly message: string;

  clearError: () => void;
  setError: (error: { title: string; message: string }) => void;
}

export const useErrorHandler = create<ErrorState>()((set) => ({
  title: "",
  message: "",

  clearError: () => set({ title: "", message: "" }),
  setError: (error) => set({ title: error.title, message: error.message }),
}));
